import { render, staticRenderFns } from "./ImageBlockFeature.vue?vue&type=template&id=23685e23&scoped=true&"
import script from "./ImageBlockFeature.vue?vue&type=script&lang=ts&"
export * from "./ImageBlockFeature.vue?vue&type=script&lang=ts&"
import style0 from "./ImageBlockFeature.vue?vue&type=style&index=0&id=23685e23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23685e23",
  null
  
)

component.options.__file = "ImageBlockFeature.vue"
export default component.exports